export const TypeEnums = {
  NOIDUNG: 0,
  VANDE: 1,
  KETQUA: 2,
  VANDEHOANTHANH: 3,
  PHATBIEU: 4,
  VANDEFULL: 5,
  KETTHUCPHIEN: 6,
  THAMDU: 7,
  CHIDINHPHATBIEU: 8,
  GHIAMPHATBIEU: 9,
  XOAPHATBIEU: 10,
  DUNGPHATBIEU: 11,
  XOAVANDE: 12,
  LAMMOI: 13,
  SHARESCREEN: 14,
  RELOADNOIDUNG: 15,
} as const;

export const ReloadEnums = {
  MOI: 0,
  DAFETCH: 1,
  HUY: 2,
} as const;
